"use strict";

var takeAll = require("./takeAll.js");

var flatL = require("../Lazy/flatL.js");

module.exports = flat;

function flat(iter, depth = 1) {
  return takeAll(flatL(iter, depth));
}